import configData from "./config.json";

// Use BUILD_ENV injected by webpack at build time, fall back to config.json value
declare const process: { env: { BUILD_ENV?: string } };
export const env = process.env.BUILD_ENV || configData.env;

// Deep merge: start with common values, then override with environment-specific values
function deepMerge(target: any, source: any): any {
  const result = { ...target };
  for (const key in source) {
    if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
      result[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

// Merge common config as base, then apply environment-specific overrides
const configEnv = deepMerge(configData.common, configData[env]);
export const config = configEnv;
